import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "user-upload"
};
const _hoisted_2 = {
  class: "reply-text"
};
const _hoisted_3 = {
  class: "keyword-content mt-4"
};
const _hoisted_4 = {
  class: "key-word mt-3"
};
const _hoisted_5 = {
  class: "left-box flex-1 overflow-hidden"
};
const _hoisted_6 = {
  class: "right-box flex-1 overflow-hidden"
};
import { computed, ref } from 'vue';
import MenuBlock from '@components/MenuBlock.vue';
import ConfirmWord from './components/ConfirmWord.vue';
import PreviewText from './components/PreviewText.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'SureKeyWordFiles',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const activeIns = ref(0);
    const activeItem = ref({});
    const info = computed(() => {
      if (props.content) {
        try {
          return props.content;
        } catch {
          return {
            knowledgeDetails: []
          };
        }
      }
      return {
        knowledgeDetails: []
      };
    });
    const tabList = computed(() => {
      const list = [];
      info.value.knowledgeDetails.forEach((item, ins) => {
        list.push({
          label: item.keyword,
          value: ins
        });
      });
      return list;
    });
    const showActiveList = computed(() => {
      const list = [[], []];
      const arr = info.value?.knowledgeDetails[activeIns.value]?.attachmentDetails || [];
      arr.forEach((item, ins) => {
        list[ins % 2].push(item);
      });
      return list;
    });
    function handleClickFull(item) {
      activeItem.value = item;
    }
    function hanTabChange() {
      const [item] = info.value.knowledgeDetails[activeIns.value].attachmentDetails;
      handleClickFull(item);
    }
    // watch(
    //   () => info.value.knowledgeDetails.length,
    //   len => {
    //     if (len > 0) {
    //       const [item] = info.value.knowledgeDetails[activeIns.value].attachmentDetails
    //       handleClickFull(item)
    //     }
    //   },
    //   { immediate: true },
    // )
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(info.value.tips), 1), _createElementVNode("div", _hoisted_3, [_createVNode(MenuBlock, {
        modelValue: activeIns.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeIns.value = $event),
        list: tabList.value,
        onChange: hanTabChange
      }, null, 8, ["modelValue", "list"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showActiveList.value[0], son => {
        return _openBlock(), _createBlock(ConfirmWord, {
          key: son.id,
          disabled: "",
          name: son.fileName,
          active: son.filePath && activeItem.value.filePath === son.filePath,
          onClickFull: $event => handleClickFull(son)
        }, null, 8, ["name", "active", "onClickFull"]);
      }), 128))]), _createVNode(PreviewText, {
        title: activeItem.value.fileName,
        "text-url": activeItem.value.filePath
      }, null, 8, ["title", "text-url"]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showActiveList.value[1], son => {
        return _openBlock(), _createBlock(ConfirmWord, {
          key: son.id,
          disabled: "",
          name: son.fileName,
          active: son.filePath && activeItem.value.filePath === son.filePath,
          onClickFull: $event => handleClickFull(son)
        }, null, 8, ["name", "active", "onClickFull"]);
      }), 128))])])])]);
    };
  }
});